<template>
  <!--eslint-disable-->
  <div class='toolbar_user'>
    <v-menu bottom offset-y right transition="scale-transition">
      <v-btn slot="activator" small :icon="isMobile" flat class='ma-0'>
        <span v-if="isDesktop" class='toolbar_user__text'>{{ user.email }}</span>
        <v-icon v-if="isDesktop">expand_more</v-icon>
        <v-icon v-else>account_circle</v-icon>
      </v-btn>
      <v-list dense>
        <v-list-tile
          :to="item.route"
          v-for="item in filteredMenu"
        >
          <v-list-tile-action><v-icon>{{ item.icon }}</v-icon></v-list-tile-action>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile @click="logout">
          <v-list-tile-action><v-icon>exit_to_app</v-icon></v-list-tile-action>
          <v-list-tile-title>Log out</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ToolBarUser',
    data() {
      return {
        items: [
          { title: 'Profile', icon: 'account_box', route: '/profile', feature: this.$features.PROFILE },
          { title: 'Track calendar', icon: 'calendar_today', route: '/reports/calendar', feature: this.$features.CALENDAR },
        ]
      }
    },
    methods: {
      logout() {
        this.$store.dispatch('logout')
        this.$router.push('/login')
      }
    },
    computed: {
      ...mapGetters(['user']),
      filteredMenu() {
        let result = []
        if(this.user) {
          this.items.map(item => {this.featureAllowed(item.feature) ? result.push(item) : false })
        }

        return result
      }
    }
  }
</script>
